import api from '../httpClient';
import type { WiseFriendAxiosRequestConfig } from '../httpClient';

const logoutTrackingConfig: WiseFriendAxiosRequestConfig = {
  wiseFriendAuth: { expectedLogoutTelemetryFailure: true },
};

export const events = {
  track: (eventType: string, eventData: any = {}) =>
    api.post('/api/events/', {
      event_type: eventType,
      event_data: eventData,
    }),
  trackLogout: (eventData: any = {}) =>
    api.post('/api/events/', {
      event_type: 'logout',
      event_data: eventData,
    }, logoutTrackingConfig),
  getEvents: (params?: { event_type?: string; user_id?: string; limit?: number }) =>
    api.get('/api/events/', { params }),
};
